import { Button } from 'components';
import {
  handleSave,
  outcomes,
  handleSubmitDisabled,
  handleThirdPartyValidations,
  isBeneficiary,
  isViewformDisabled,
  isCoe,
} from 'utils';
import { thirdPartyValidations } from 'store/forms/actions';
import { getLocalString, localNames } from 'utils/localisation.service';
import { validAFM } from 'utils';
import { updateFormField } from 'store/forms/actions';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  useCarrierUsersValidation,
  useInvestorApplicationValidation,
} from 'hooks/useInvestorApplicationValidation';
import { types } from 'store/forms/types';

export function RenderButtons({
  task,
  state,
  dispatch,
  saveTask,
  taskId,
  formId,
  setIsVisible,
  setIsApproveVisible,
  setIsRejectVisible,
  setIsReturnToCoeVisible,
  setOutcome,
  user,
  viewMode,
  locales,
  providerDoc,
  lockSubmitBanner,
  location,
  setViewformSubmitVisible,
  activeTaskName,
}) {
  const formKey = task.formKey;
  const isSaved = state?.carrier?.rejectReasons?.isSubmitValid ? true : false;
  const isUserKTP =
    user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      ? user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      : false;
  const isUserProvider =
    user.groups?.filter(a => a.id.startsWith('ProviderResourceGroup')).length >
    0
      ? user.groups?.filter(a => a.id.startsWith('ProviderResourceGroup'))
          .length > 0
      : false;
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const parseFlag = useSelector(
    state => state.appTrack?.apptrackDetails?.variablesIndexed?.parseFlag
  );
  const { isValidCarrierUsers } = useCarrierUsersValidation();
  const ApplicationFilesList = useSelector(
    state => state.appTrack?.apptrackDetails?.contentItems
  );
  const bankChanged = useSelector(state => state.forms?.bankChanged);
  const { isValid, logValidation } = useInvestorApplicationValidation();

  const isCoeApproveEnabled = () => {
    const requiredFields = [
      'businessPlanFile',
      'eligibilityFile',
      'financialModelFile',
    ];

    return requiredFields?.every(field =>
      ApplicationFilesList?.some(file => file?.items[0]?.field === field)
    );
  };

  const phaseApproveReject =
    isBeneficiary(user?.groups) &&
    [
      'task.name.program_implementation_complete',
      'task.name.submit_objection',
    ].includes(task?.taskName);

  const isCoeEdit =
    isCoe(user?.groups) &&
    !isViewMode &&
    !location?.pathname.includes('disabled');

  return (
    <div className="app-layout__buttons">
      {
        // TODO: Maybe it's better to make a dedicated button component and encapsulate relevant hooks/calculations
        !location?.pathname.includes('apptrack') &&
          (viewMode ? bankChanged : true) &&
          isBeneficiary(user?.groups) &&
          !phaseApproveReject && (
            // user.privileges?.includes("CanRenderSaveBtn") &&
            <Button
              type="default"
              id="saveButton"
              // id="create-application-button"
              label={getLocalString(
                locales,
                localNames.REQUEST_PAGE_SAVEBUTTON
              )}
              disabled={(viewMode && !bankChanged) || !isValidCarrierUsers}
              onClick={() => {
                handleSave({
                  state,
                  dispatch,
                  saveTask,
                  taskId,
                  formId,
                  isSaved,
                });
                dispatch({
                  type: types.SET_BANK_CHANGED,
                  payload: false,
                });

                logValidation();
              }}
            />
          )
      }
      {!location?.pathname.includes('apptrack') &&
        !viewMode &&
        isBeneficiary(user?.groups) &&
        !phaseApproveReject && (
          // user.privileges?.includes("CanRenderSubmitBtn") &&
          <Button
            type="default"
            className={'ant-btn-primary submit-btn'}
            id="submit-btn"
            // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
            label={'Υποβολή στο CoE'}
            disabled={
              false
              // !isValid
              // Is any of this logic still relevant?
              //   lockSubmitBanner?.render ||
              //   handleSubmitDisabled({
              //   user: { ...user},
              //   state: { ...state },
              //   formKey,
              // })
            }
            onClick={() => {
              setOutcome(outcomes.submitBeneficiary);
              setIsVisible(true);
            }}
          />
        )}
      {location?.pathname.includes('apptrack') &&
        activeTaskName == 'task.name.application_evaluated' &&
        // && activeTaskName == 'task.name.submit_application'
        !viewMode &&
        isBeneficiary(user?.groups) && (
          // user.privileges?.includes("CanRenderSubmitBtn") &&
          <>
            <Button
              type="default"
              id="return-to-coe-button"
              className={'ant-btn-primary return-btn'}
              label="Επιστροφή στο COE"
              onClick={() => {
                setOutcome(outcomes.returnToCoe);
                setIsReturnToCoeVisible(true);
              }}
            />
            <Button
              type="default"
              id="create-application-button"
              label="Υποβολή στο ΤΑΑ"
              //   disabled={
              //     lockSubmitBanner?.render ||
              //     handleSubmitDisabled({
              //     user: { ...user},
              //     state: { ...state },
              //     formKey,
              //   })
              // }
              onClick={() => {
                setOutcome(outcomes.evaluationApproval);
                // handleThirdPartyValidations({
                //     state: { ...state },
                //     user,
                //     dispatch,
                //     taskId,
                //     formId,
                //     thirdPartyValidations,
                //   }).then(res => {
                // const reasons ={
                //   case:'thirdPartyValidations',
                //   acceptable: res.acceptable, //DEV true for easier development, do not push
                //   responseCode: res.responseCode,
                //   isGreekAfm: validAFM(user?.taxis_data?.afm),
                //   isActive: true
                //   }
                // if (reasons.acceptable && reasons.isGreekAfm && reasons.isActive) {
                //   setOutcome(outcomes.submitNP);
                setViewformSubmitVisible(true);
                // }
                //  else {
                //   reasons.isSubmitValid = false;
                //   dispatch(
                //     updateFormField({
                //       group: 'carrier',
                //       key: 'rejectReasons',
                //       value: reasons,
                //     })
                //   )

                //     handleSave({
                //       state,
                //       dispatch,
                //       saveTask,
                //       taskId,
                //       formId,
                //       isSaved: false,
                //     })
                //   }
                // });
              }}
            />
          </>
        )}

      {isCoeEdit && (
        <Button
          type="default"
          id="reject-btn"
          className={'ant-btn-primary reject-btn'}
          disabled={isViewformDisabled(window.location.pathname)}
          label={getLocalString(
            locales,
            localNames.REQUEST_PAGE_OUTLINE_REJECT
          )}
          // disabled={viewMode}
          onClick={() => {
            setOutcome(outcomes.evaluationRejection);
            setIsRejectVisible(true);
          }}
        />
      )}
      {isCoeEdit && (
        <Button
          type="default"
          id="submit-btn"
          className={'ant-btn-primary submit-btn'}
          label={getLocalString(
            locales,
            localNames.REQUEST_PAGE_OUTLINE_APPROVE
          )}
          disabled={
            isViewformDisabled(window.location.pathname) ||
            parseFlag !== false ||
            !isCoeApproveEnabled()
          }
          onClick={() => {
            setOutcome(outcomes.evaluationApproval);
            setIsApproveVisible(true);
          }}
        />
      )}

      {phaseApproveReject && !window.location.pathname.includes('view') && (
        <>
          <Button
            type="default"
            id="reject-btn"
            className={'ant-btn-primary reject-btn'}
            label={getLocalString(
              locales,
              localNames.REQUEST_PAGE_OUTLINE_REJECT
            )}
            disabled={false}
            onClick={() => {
              setOutcome(
                task?.taskName === 'task.name.program_implementation_complete'
                  ? outcomes.rejectBeneficiary
                  : outcomes.rejectAudit
              );
              setIsVisible(true);
            }}
          />
          <Button
            type="default"
            id="submit-btn"
            className={'ant-btn-primary submit-btn'}
            label={getLocalString(
              locales,
              localNames.REQUEST_PAGE_OUTLINE_APPROVE
            )}
            disabled={false}
            onClick={() => {
              setOutcome(
                task?.taskName === 'task.name.program_implementation_complete'
                  ? outcomes.approveBeneficiary
                  : outcomes.approveAudit
              );
              setIsVisible(true);
            }}
          />
        </>
      )}
      {isUserProvider &&
        !window.location.pathname.includes('view') &&
        !['task.name.submit_objection'].includes(task?.taskName) && (
          // user.privileges?.includes("CanRenderSaveBtn") &&
          <Button
            type="default"
            id="saveButton"
            label={getLocalString(locales, localNames.REQUEST_PAGE_SAVEBUTTON)}
            disabled={!isSaved || !providerDoc}
            onClick={() => {
              handleSave({
                state,
                dispatch,
                saveTask,
                taskId,
                formId,
                isSaved,
              });
              //redirect to homepage for provider save button
              setTimeout(
                () =>
                  (window.location.href =
                    window.location.origin + '/go-beyond/appTrack'),
                1000
              );
            }}
          />
        )}
    </div>
  );
}
